export const mapZIndexes = {
	// assume water is z=0, so make terrain "overlay" go under it (temporary fix for water not covering it)
	terrainOverlay: -1,
	//objMesh: 1,
	/** The z-RANGE the 2D scenery tree quads occupy (the crown-top depth-ordering band). Trees are
	 *  lifted to `sceneryZ_start + crownTopMetres * depthScale`, spanning `[start, end]`. Reserving
	 *  0-9 for ad-hoc groups; scenery owns [10,100]; the rest (145+) is icons/objects/labels/camera.
	 *  See `SceneryRenderer`'s `TREE_DEPTH_SCALE`. */
	sceneryZ_start: 10,
	sceneryZ_end: 100,
	anchorIcons_low_last: 145, // 120-145
	objShape: 150,
	isolineSamplePoints: 160,
	polygonGuideGrid: 170,
	/** Set15 P0: ground-projected frustum wedge for aiming a `Mod_Viewpoint` in 2D. */
	viewpointOverlay: 175,
	cursor: 180,
	toolPreview: 190,
	anchorIcons_mid_last: 799, // ?-799 (same sequencing as below; max set just below objLabel)
	objLabel: 800,
	anchorIcons_high_last: 1200, // ?-1200 (1200 is z-index of newest dream-scene's anchor-icon)
	camera: 1500, // should be the final/highest entry
};